import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import FIELD_TYPES from '../../../../../../configs/fieldTypes';
import * as AXIS_TYPES from '../../../../../../configs/reports/widget/axisTypes';
import * as AXIS_SUB_TYPES from '../../../../../../configs/grid/axisSubTypes';
import Dropdown from '../../../../../common/Dropdown';
import { parseFieldWithSubType, fieldWithSubTypeToString } from '../../../../../../utils/viewSettings';
import { getDateItems } from '../../../../../../utils/getDateItems';

const getValueKey = ({ type, subType, fieldId, value }) => {
  const keyValue = type === 'field' ? fieldId || value : value;
  return type + (subType || '') + (keyValue || '');
};

class GroupSelect extends React.PureComponent {
  getAvailableValues(fields) {
    return _.compact(
      _.flatten(
        fields
          .toArray()
          .filter(
            (field) =>
              field.get('type') !== FIELD_TYPES.CONTACT &&
              field.get('type') !== FIELD_TYPES.ADDRESS &&
              field.get('type') !== FIELD_TYPES.FILE &&
              field.get('type') !== FIELD_TYPES.GROUP &&
              field.get('type') !== FIELD_TYPES.IFRAME,
          )
          .map((field) => {
            const fieldId = field.get('id');
            const fieldName = field.get('name');

            if (field.get('type') === FIELD_TYPES.DATE) {
              return getDateItems(field.getIn(['config', 'type']))
                .filter(
                  ({ subType }) =>
                    subType !== AXIS_SUB_TYPES.DAY_OF_WEEK &&
                    subType !== AXIS_SUB_TYPES.WEEK_OF_YEAR &&
                    subType !== AXIS_SUB_TYPES.MONTH_OF_YEAR &&
                    subType !== AXIS_SUB_TYPES.QUARTER_OF_YEAR,
                )
                .map(({ title, subType }) => ({
                  type: AXIS_TYPES.FIELD,
                  subType,
                  title: `${fieldName} ${title}`,
                  fieldId,
                }));
            }
            return {
              type: AXIS_TYPES.FIELD,
              fieldId,
              title: fieldName,
            };
          }),
      ),
    ).map((item) => ({
      ...item,
      key: getValueKey(item),
      text: item.title,
    }));
  }

  fieldIdsToKeys = (groups) => {
    if (!groups) return [];

    const groupKeys = Immutable.List.isList(groups) ? groups.toArray() : groups;

    return groupKeys.map((groupKey) => {
      const { fieldId, subType } = parseFieldWithSubType(groupKey);
      return getValueKey({ type: AXIS_TYPES.FIELD, fieldId, subType });
    });
  };

  keysToFieldIds = (items = []) =>
    items
      .filter(Boolean)
      .map((item) => fieldWithSubTypeToString({ fieldId: item.fieldId, subType: item.subType }))
      .filter(Boolean);

  onSelectItems = (items) => {
    const { onChange } = this.props;
    if (!onChange) return;

    onChange(Immutable.List(this.keysToFieldIds(items)));
  };

  render() {
    const { fields, value, disabled } = this.props;
    const availableValues = this.getAvailableValues(fields);

    return (
      <Dropdown
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        items={availableValues}
        multiselect
        value={this.fieldIdsToKeys(value)}
        autocomplete
        withButton
        disabled={disabled}
        onSelectItems={this.onSelectItems}
      />
    );
  }
}

GroupSelect.propTypes = {
  fields: ImmutablePropTypes.list.isRequired,
  value: PropTypes.oneOfType([ImmutablePropTypes.list, PropTypes.array]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default GroupSelect;
